import React, { Suspense, lazy } from "react";
import { Navigate, Route, useParams } from "react-router-dom";
import { RequirePortalAuth } from "../pages/Login";
import NaturalsControlLayout from "./NaturalsControlLayout";
import { ENTERPRISE_CONTROL_BASE } from "./constants";

const Fallback = () => (
  <div className="min-h-[40vh] flex items-center justify-center text-[#6b6280]">Loading…</div>
);

const NaturalsDashboardPage = lazy(() => import("./pages/NaturalsDashboardPage"));
const NaturalsOrganizationsPage = lazy(() => import("./pages/NaturalsOrganizationsPage"));
const NaturalsOrganizationDetailPage = lazy(() => import("./pages/NaturalsOrganizationDetailPage"));
const NaturalsLicensesHubPage = lazy(() => import("./pages/NaturalsLicensesHubPage"));
const NaturalsAuditPage = lazy(() => import("./pages/NaturalsAuditPage"));

const PORTAL_HOME = "/naturals-portal/home";
const PORTAL_ORG_EDIT_BASE = "/naturals-portal/organizations";

function LegacyOrgDetailRedirect() {
  const { orgId } = useParams();
  return <Navigate to={`${ENTERPRISE_CONTROL_BASE}/organizations/${orgId}`} replace />;
}

function ManageToOrgRedirect() {
  const { orgId } = useParams();
  return <Navigate to={`${ENTERPRISE_CONTROL_BASE}/organizations/${orgId}`} replace />;
}

function NaturalsControlCreateRedirect() {
  return <Navigate to={PORTAL_HOME} replace />;
}

function NaturalsControlEditRedirect() {
  const { orgId } = useParams();
  return <Navigate to={`${PORTAL_ORG_EDIT_BASE}/${orgId}/edit`} replace />;
}

export function renderNaturalsControlRoutes() {
  return (
    <Route
      path={ENTERPRISE_CONTROL_BASE}
      element={
        <RequirePortalAuth>
          <NaturalsControlLayout />
        </RequirePortalAuth>
      }
    >
      <Route
        index
        element={
          <Suspense fallback={<Fallback />}>
            <NaturalsDashboardPage />
          </Suspense>
        }
      />
      <Route
        path="organizations"
        element={
          <Suspense fallback={<Fallback />}>
            <NaturalsOrganizationsPage />
          </Suspense>
        }
      />
      <Route
        path="organizations/:orgId"
        element={
          <Suspense fallback={<Fallback />}>
            <NaturalsOrganizationDetailPage />
          </Suspense>
        }
      />
      <Route path="organizations/:orgId/manage" element={<ManageToOrgRedirect />} />
      <Route path="organizations/new" element={<NaturalsControlCreateRedirect />} />
      <Route path="organizations/:orgId/edit" element={<NaturalsControlEditRedirect />} />
      <Route
        path="licenses"
        element={
          <Suspense fallback={<Fallback />}>
            <NaturalsLicensesHubPage />
          </Suspense>
        }
      />
      <Route
        path="audit"
        element={
          <Suspense fallback={<Fallback />}>
            <NaturalsAuditPage />
          </Suspense>
        }
      />
      <Route path="*" element={<Navigate to={ENTERPRISE_CONTROL_BASE} replace />} />
    </Route>
  );
}

export { LegacyOrgDetailRedirect, ENTERPRISE_CONTROL_BASE };
